module.exports = __webpack_public_path__ + "static/media/coin.694bbe35.png";